  // checks if the whole field is valid/ready to be sent back to the form
  function isFormFieldValid(fieldType, fieldLabel, fieldOptions) {
    if (!fieldType || !fieldLabel) {
      return false;
    }
    else if (fieldType != 'multiple_choice') {
      return true;
    }
    else return !!fieldOptions;
  }

    /** this function should only be called for a valid options list */
  function getFieldConfigFromOptionsString(fieldType, fieldOptions) {
    if (fieldType == 'multiple_choice') {
      const choices = fieldOptions.split(',').map(option => ({ name: option }));
      return { choices };
    }
  }

  function getOptionsStringFromFieldConfig(field) {
    if (field.field_type == 'multiple_choice' && field.config && field.config.choices) {
      return field.config.choices.map(choice => choice.name).join();
    }
    return null;
  }

  export default {
    isFormFieldValid,
    getFieldConfigFromOptionsString,
    getOptionsStringFromFieldConfig,
  };



// WEBPACK FOOTER //
// ./src/components/Forms/FormBuilder/formBuilderHelper.js